import api from './api';
import ErrorService from './errorService';
import { getConsultantId } from '../Redux/UsersDucks';
import { ApiService } from './apiService';

export const InterviewService = {
    getInterviewByHubspotId: async (hubspotId) => {
        //const contractId = 60
        try {
            const response = await ErrorService.withTimeout(api.get(`/CustomerInterview/ByHubspot/${hubspotId}`));
            return response.data;

        } catch (error) {
            //ErrorService.handleApiError('Error al obtener datos contracto:', error);
            return null
            //throw error;
        }
    },
    getCustomerInterviewId:async (customerInterviewId) => {
        //const contractId = 60
        try {
            const response = await ErrorService.withTimeout(api.get(`/CustomerInterview/CustomerInterviewId/${customerInterviewId}`));
            return response.data;

        } catch (error) {
            //ErrorService.handleApiError('Error al obtener datos contracto:', error);
            return null
            //throw error;
        }
    }, 

    startInterview: async (hubspotId) => {
        const agentId = getConsultantId();
        if (!agentId) {
            throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
        }

        try {

            const payload = {
                hubspotId: hubspotId,
                userId: agentId,
              }
            const response = await ErrorService.withTimeout(api.post(`/CustomerInterview`,payload));
            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos contracto:', error);
            throw error;
        }
    },

    updateInterview: async (payload) => {
        const agentId = getConsultantId();
        if (!agentId) {
            throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
        }

        try {
            payload.userId = agentId

            const response = await ErrorService.withTimeout(api.put(`/CustomerInterview`,payload));
            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos contracto:', error);
            throw error;
        }
    },

    UpdateHojaAtencion: async (payload) => {
        const agentId = getConsultantId();
        if (!agentId) {
            throw new Error('Consultor. Se debe de ingresar en el sistema es requerido su rut.');
        }

        try {
            payload.userId = agentId

            const response = await ErrorService.withTimeout(api.put(`/CustomerInterview/UpdateHojaAtencion`,payload));
            return response.data;

        } catch (error) {
            ErrorService.handleApiError('Error al obtener datos contracto:', error);
            throw error;
        }
    },

}